import { RootState } from "redux/store";
import { LensRunState } from "./lensRun.slice";

export const selectLensRun = (state: RootState): LensRunState => state.lensRun;
